<template>
  <main-layout v-if="wave">
    <template slot="header-title">{{wave.name}}</template>

    <template slot="main">
      <div class="container mx-auto mb-10 grid grid-cols-2 gap-4">

        <div>
          <h2 class="text-xl mb-1">Total shares made according to the number of wave displayed</h2>
          <div class="bg-white rounded shadow p-8">
            <div class="mb-2">
              <div class="mt-2">
                <canvas id="graph1"></canvas>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2 class="text-xl mb-1">Total views by steps</h2>
          <div class="bg-white rounded shadow p-8">
            <div class="mb-2">
              <div class="mt-2">
                <canvas id="graph2"></canvas>
              </div>
            </div>
          </div>
        </div>

      </div>

    </template>
  </main-layout>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { Chart } from 'chart.js'

export default {
  name: 'WaveStats',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loaded: false,
      chart: null
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('waves', {
      getById: 'getById'
    }),

    wave () {
      return this.getById(this.id)
    }
  },

  watch: {
    site: {
      handler: 'initWave',
      immediate: true
    }
  },

  methods: {
    ...mapActions('waves', ['loadWave', 'getStepStats', 'getStepStatsPerDay']),

    initWave () {
      this.loadWave({id: this.id}).then((wave) => {
        // Graph 1
        this.getStepStatsPerDay({id: this.id}).then((results) => {
          // Chart 1
          const ctx = document.getElementById('graph1')
          if (ctx) {
            this.chart = new Chart(ctx, {
              type: 'bar',
              data: {
                datasets: [{
                  label: 'Number of actions taken by the community',
                  data: Object.entries(results).map(a => a[1].total_done),
                  type: 'line',
                  fill: false,
                  yAxesID: 'B',
                  backgroundColor: '#f368e0',
                  borderColor: '#f368e0'
                }, {
                  label: 'Number of actions taken by the audience',
                  data: Object.entries(results).map(a => a[1].total),
                  backgroundColor: '#00d2d3',
                  borderColor: '#00d2d3',
                  yAxesID: 'B',
                  type: 'line',
                  fill: false
                },
                {
                  label: 'Number of runs completed per audience',
                  data: Object.entries(results).map(a => a[1].total_done),
                  backgroundColor: '#01a3a4',
                  borderColor: '#01a3a4',
                  yAxesID: 'A'
                }, {
                  label: 'Number of routes posted to the audience',
                  data: Object.entries(results).map(a => a[1].total),
                  backgroundColor: '#ff9ff3',
                  borderColor: '#ff9ff3',
                  yAxesID: 'A'
                }
                ],
                labels: Object.entries(results).map(a => a[0])
              },
              options: {
                legend: {
                  position: 'bottom'
                },
                scales: {
                  yAxes: [
                    {
                      id: 'A',
                      type: 'linear',
                      position: 'left',
                      ticks: {
                        beginAtZero: true
                      }
                    },
                    {
                      id: 'B',
                      type: 'linear',
                      position: 'right',
                      ticks: {
                        beginAtZero: true
                      },
                      gridLines: {
                        drawOnChartArea: false // only want the grid lines for one axis to show up
                      }
                    }
                  ],
                  xAxes: [{
                    display: true,
                    ticks: {
                      beginAtZero: true
                    }
                  }]
                }
              }
            })
          }
        })

        // Graph 2
        this.getStepStats({id: this.id}).then((data) => {
          // Chart 2
          var color = Chart.helpers.color
          var horizontalBarChartData = {
            labels: this.getLabels(data.results.steps.length),
            datasets: [{
              label: 'Number of view',
              backgroundColor: color('rgb(255, 99, 132)').alpha(0.5).rgbString(),
              borderColor: 'rgb(255, 99, 132)',
              data: Object.entries(data.results.steps).map(result => result[1].views.total)
            }, {
              label: 'Unique view number',
              backgroundColor: color('rgb(54, 162, 235)').alpha(0.5).rgbString(),
              borderColor: 'rgb(54, 162, 235)',
              data: Object.entries(data.results.steps).map(result => result[1].views.unique)
            }]
          }

          const ctx2 = document.getElementById('graph2')
          if (ctx2) {
            let parameters = {
              type: 'horizontalBar',
              data: horizontalBarChartData,
              options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                  rectangle: {
                    borderWidth: 2
                  }
                },
                responsive: true,
                legend: {
                  position: 'bottom'
                },
                title: {
                  display: false
                },
                scales: {
                  xAxes: [{
                    display: true,
                    ticks: {
                      beginAtZero: true // minimum value will be 0.
                    }
                  }]
                }
              }
            }
            if (horizontalBarChartData.labels.length === 0) {
              parameters.options['tooltips'] = {
                callbacks: {
                  title: function () {}
                }
              }
            }
            this.chart = new Chart(ctx2, parameters)
          }
        })
      })
    },

    getLabels (numberOfSteps) {
      var labels = []
      if (numberOfSteps <= 1) {
        return labels
      }
      for (let i = 0; i < numberOfSteps; ++i) {
        if (i + 1 === numberOfSteps) {
          labels.push('Final Step')
        } else {
          labels.push('Step ' + (i + 1))
        }
      }
      return labels
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Wave/WaveStats.vue